<template>
  <DialogTemplate
    v-bind="{ ...props, ...attrs }"
    ref="element"
    align="center"
    class="dialog"
    :class="{ dark: !isParent }"
    :show-controls="true"
    :scrollable="true"
    theme="secondary-dark"
  >
    <icon v-if="isAboveL" name="nomad:diamond-stars" :size="diamondSize" />
    <h2>
      Bienvenue dans <strong>Nomad+ <icon name="nomad:diamond" /></strong>
    </h2>
    <p v-cleaned="titleDescription" />

    <div class="contents">
      <h3 class="subtitle">
        {{ subTitle }}&nbsp;<icon name="nomad:diamond" />
      </h3>
      <p v-if="description" v-cleaned="description" class="description" />

      <DialogSubscriberSlide />
      <ButtonBase
        ref="buttonElement"
        rounded
        class="button"
        theme="secondary"
        variant="tonal"
        size="small"
        stroke="n"
        @click="() => dialog.close()"
      >
        Let’s go !
      </ButtonBase>
    </div>
  </DialogTemplate>
</template>
<script lang="ts" setup>
import { getLevelOfEducationGroup, LevelOfEducationGroup } from '~/lib/level';

interface Props {}

const props = defineProps({
  
});

const attrs = useAttrs();

const dialog = useDialogStore();

const profile = useProfileStore();

const isParent = computed(() => {
  return profile.isParent;
});

const subTitle = computed(() => {
  if (isParent.value) {
    return 'Inclus dans votre Abo';
  } else {
    return 'Inclus dans ton Abo';
  }
});

const groupId = computed(() => {
  return getLevelOfEducationGroup(profile.levelOfEducationId);
});

const description = computed(() => {
  if (isParent.value) return '';
  switch (groupId.value) {
    case LevelOfEducationGroup.SHOOL_3:
      return '<strong>Tous tes contenus BREVET</strong> pour viser la Mention 🎯';
    case LevelOfEducationGroup.First:
      return '<strong>Tous tes contenus</strong> pour réussir ton année et ton Bac de Français 🚀';
    case LevelOfEducationGroup.Terminal:
      return '<strong>Tous tes contenus BAC</strong> pour viser la Mention 🎯';
    default:
      return '<strong>Tous tes contenus</strong> pour booster ta moyenne et réussir ton année 🚀';
  }
});

const titleDescription = computed(() => {
  if (isParent.value) {
    return `Tous les contenus pour gagner des points de moyenne et réussir son année 🎯`;
  } else {
    return 'T’as déverrouillé le mode boss 💪🏻 Let’s go vers la réussite !';
  }
});

const breakpoints = useEvaBreakpoints();

const isAboveL = breakpoints.greaterOrEqual('l');

const diamondSize = computed(() => {
  return isAboveL.value ? '5rem' : '4rem';
});
</script>
<style lang="scss" scoped>
.dialog {
  --color_text: var(--color_neutral_800);
  --color_highlight: var(--color_primary);
  --color_background: var(--color_primary_lighter);
  --color_background_lighter: var(--color_neutral_50);
  &.dark {
    --color_text: var(--color_neutral_25);
    --color_highlight: var(--color_secondary);
    --color_background: var(--color_secondary_darker);
    --color_background_lighter: var(--color_secondary_dark);
  }

  position: relative;
  width: 100%;
  max-width: 61.8rem;
  max-width: auto;

  // padding: var(--gap_l);
  padding: var(--gap_l) var(--gap_n) 0;
  overflow: hidden;
  border-width: 0;
  border-color: transparent;
  background-color: var(--color_background);
  text-align: center;
  gap: var(--gap_l);
  .button {
    padding-right: 5rem;
    padding-left: 5rem;
  }
}

p {
  @include font('n', 400, 'secondary');

  color: var(--color_text);
}

h2 {
  @include font('xl', 800, 'secondary');

  color: var(--color_text);

  :deep(strong) {
    display: inline-block;
    position: relative;
    z-index: 1;
    padding: 0 var(--gap_s);
    color: var(--color_neutral_50);

    &::before {
      content: '';
      position: absolute;
      z-index: -1;
      top: 0.4rem;
      left: 0;
      width: 100%;
      height: calc(100% - 0.8rem);
      border-radius: 1.6rem;
      background-color: var(--color_highlight);
    }
  }
}

h3.subtitle {
  @include font('l', 700, 'secondary');

  color: var(--color_text);
}

.description {
  @include font('n', 400, 'secondary');

  max-width: 32rem;
  color: var(--color_text);

  :deep(strong) {
    display: inline-block;
    position: relative;
    z-index: 1;
    font-weight: 400;
    &::after {
      content: '';
      position: absolute;
      z-index: -1;
      bottom: 10%;
      left: 0;
      width: 100%;
      height: 70%;
      background-color: var(--color_highlight);
    }
  }
}

.subtitle,
.description {
  @include mobile {
    display: none;
  }
}

.contents {
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  width: stretch;
  width: calc(100% - 3.6rem);
  padding: var(--gap_l) var(--gap_n);
  border-radius: 2rem 2rem 0 0;

  // margin: 0 auto;
  background-color: var(--color_background_lighter);
  gap: var(--gap_n);
}

:deep(footer) {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
